export class Content {
	contentId: number;
	contentTypeId: number;
	category: string;
	statementMonth: string;
	shortTermRentalId: number;
	developmentId: number;
	locationId: number;
	adrRegion: string;
	title: string;
	slug: string;
	bodyHtml: string;
	bodyText: string;
	summary: string;
	metaTitle: string;
	metaDescription: string;
	keywords: string;
	schemaType: string;
	schemaJson: string;
	status: string;
	generatedBy: string;
	generatedDate: Date;
	reviewedBy: string;
	reviewedDate: Date;
	publishedDate: Date;
	scheduledPublishDate: Date;
	sortOrder: number;
	enabled: boolean;
	featured: boolean;
	viewCount: number;
	createDate: Date;
	lastUpdate: Date;
	mediaList: ContentMedia[];
	faqList: ContentFaq[];
}

export interface ContentRevision {
	revisionId: number;
	revisionNum: number;
	title: string;
	status: string;
	changedByUserId: number;
	changeDate: Date;
	changeSummary: string;
}

export class ContentMedia {
	contentMediaId: number;
	contentId: number;
	mediaType: number;
	title: string;
	caption: string;
	altText: string;
	fileName: string;
	amazonBucketName: string;
	url: string;
	thumbnailUrl: string;
	width: number;
	height: number;
	fileSizeBytes: number;
	mimeType: string;
	sortOrder: number;
	featured: boolean;
	enabled: boolean;
}

export class ContentFaq {
	contentFaqId: number;
	contentId: number;
	sectionName: string;
	questionDesc: string;
	answerDesc: string;
	imageUrl: string;
	displayOrder: number;
	enabled: boolean;
}
